import React, { useState, useMemo } from 'react';
import { audioData } from '../data/audioData';

import SheikhsImage from '../assest/New folder/IMG_2050 (1).jpg';
import NationalImage from '../assest/New folder/Screenshot 2025-10-28 144106.png';
import SpecialImage from '../assest/New folder/4567.jpg';
import PoemsImage from '../assest/New folder/2ac9d6b6-f792-4772-9ef9-fd5f4c5ebac7.jpg';

/**
 * MusicLibrary Component
 * Displays four main music categories with images
 */
const MusicLibrary = () => {
  const [activeCategory, setActiveCategory] = useState(null);

  const categories = useMemo(() => [
    {
      id: 1,
      title: 'أغاني مهداة للشيوخ',
      description: 'أجمل الأغاني المهداة لقادتنا وشيوخنا الكرام',
      gradient: 'from-gold to-gold-light',
      bgImage: SheikhsImage,
      count: audioData.filter(t => t.libraryCategoryId === 1).length
    },
    {
      id: 2,
      title: 'أغاني وطنية',
      description: 'أغاني الوطن والانتماء والفخر',
      gradient: 'from-primary to-primary-dark',
      bgImage: NationalImage,
      count: audioData.filter(t => t.libraryCategoryId === 2).length
    },
    {
      id: 3,
      title: 'أغاني الشهيد',
      description: 'مجموعة مميزة من الأغاني الخاصة والحصرية',
      gradient: 'from-gold-dark to-primary-light',
      bgImage: SpecialImage,
      count: audioData.filter(t => t.libraryCategoryId === 3).length
    },
    {
      id: 4,
      title: 'قصائد وطنية',
      description: 'قصائد شعرية تحكي قصة الوطن والأمجاد',
      gradient: 'from-beige-dark to-primary',
      bgImage: PoemsImage,
      count: audioData.filter(t => t.libraryCategoryId === 4).length
    }
  ], [audioData]);

  return (
    <div className="bg-gradient-to-br from-primary-dark/90 via-primary/80 to-gray-900/90 backdrop-blur-xl rounded-3xl p-6 h-full border border-gold/20 shadow-2xl">
      {/* Header */}
      <div className="flex items-center justify-between mb-6" dir="rtl">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-gold to-gold-light rounded-xl flex items-center justify-center shadow-lg">
            <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
            </svg>
          </div>
          <div>
            <h2 className="text-xl font-bold text-white">المكتبة الموسيقية</h2>
            <p className="text-gold/70 text-sm">اختر تصنيفك المفضل</p>
          </div>
        </div>

        {/* Total Count Badge */}
        <div className="bg-gold/20 px-4 py-2 rounded-full">
          <span className="text-gold font-bold text-sm">
            {categories.reduce((acc, cat) => acc + cat.count, 0)} أغنية
          </span>
        </div>
      </div>

      {/* Categories Grid */}
      <div className="grid grid-cols-2 gap-4" dir="rtl">
        {categories.map((category) => (

          // ✅ Wrapper خارجي يضمن بقاء الحواف دائرية دائماً
          <div
            key={category.id}
            className="rounded-2xl overflow-hidden"
            style={{ isolation: 'isolate' }}
          >
            <div
              className={`relative group cursor-pointer rounded-2xl overflow-hidden
                transition-all duration-500 transform hover:scale-105 hover:shadow-2xl
                border-2 ${
                  activeCategory === category.id
                    ? 'border-gold/70 scale-105 shadow-lg shadow-gold/20'
                    : 'border-transparent'
                }`}
              onClick={() => setActiveCategory(activeCategory === category.id ? null : category.id)}
            >
              {/* Background Image */}
              <div className="absolute inset-0">
                <img
                  src={category.bgImage}
                  alt={category.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                {/* Gradient Overlay */}
                <div className={`absolute inset-0 bg-gradient-to-t ${category.gradient} opacity-80 group-hover:opacity-70 transition-opacity duration-300`}></div>
                {/* Dark Overlay for text readability */}
                <div className="absolute inset-0 bg-black/30"></div>
              </div>

              {/* Content */}
              <div className="relative p-5 h-40 flex flex-col justify-end">
                {/* Text Content */}
                <div>
                  <h3 className="text-white font-bold text-lg mb-1 group-hover:text-gold-light transition-colors duration-300">
                    {category.title}
                  </h3>
                  <p className="text-white/70 text-xs line-clamp-2 group-hover:text-white/90 transition-colors duration-300">
                    {category.description}
                  </p>
                </div>

                {/* Count Badge */}
                <div className="absolute top-4 left-4 bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full">
                  <span className="text-white text-xs font-bold">{category.count} أغنية</span>
                </div>

                {/* Play Button - Appears on hover */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center transform scale-75 group-hover:scale-100 transition-transform duration-300">
                    <svg className="w-8 h-8 text-white mr-[-2px]" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M8 5v14l11-7z"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

        ))}
      </div>

      {/* Playlist Panel */}
      {activeCategory && (
        <div className="mt-6 bg-gray-900/70 rounded-2xl border border-gold/30 p-4" dir="rtl">
          {(() => {
            const activeCategoryData = categories.find(c => c.id === activeCategory);
            const filteredTracks = audioData.filter(
              track => track.libraryCategoryId === activeCategory
            );

            return (
              <>
                <h3 className="text-gold text-lg font-bold mb-3">
                  {activeCategoryData ? `قائمة ${activeCategoryData.title}` : 'قائمة الأغاني'}
                </h3>

                {filteredTracks.length === 0 ? (
                  <p className="text-gray-300 text-sm">
                 قريباً
                  </p>
                ) : (
                  <div className="space-y-3 max-h-64 overflow-y-auto pr-1">
                    {filteredTracks.map((track) => (
                      <div
                        key={track.id}
                        className="flex flex-col gap-3 bg-white/5 hover:bg-white/10 rounded-xl px-3 py-3 transition-colors"
                      >
                        <div className="flex flex-col gap-1">
                          <p className="text-gold text-sm md:text-base lg:text-lg font-bold">
                            {track.titleAr}
                          </p>
                         {/*  {track.description && (
                            <p className="text-gray-300 text-xs truncate">{track.description}</p>
                          )} */}
                        </div>
                        <div className="flex items-center justify-between gap-3">
                          <span className="text-gold text-xs font-bold whitespace-nowrap">
                            {track.duration}
                          </span>
                          <div className="flex items-center gap-2 flex-1 justify-end">
                            <audio src={track.url} controls className="w-40 h-8" />
                            <a
                              href={track.url}
                              download
                              className="text-xs px-3 py-1 rounded-full bg-gold text-primary font-bold hover:bg-gold-light transition-colors whitespace-nowrap"
                            >
                              تحميل
                            </a>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            );
          })()}
        </div>
      )}

      {/* Bottom Info */}
      <div className="mt-6 pt-4 border-t border-gold/20">
        <div className="flex items-center justify-center gap-2 text-gold/70 text-sm" dir="rtl">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          <span>انقر على أي تصنيف لاستعراض المحتوى</span>
        </div>
      </div>
    </div>
  );
};

export default MusicLibrary;